// js
import React from 'react';
import PropTypes from 'prop-types';
import RollUpOverviewStatPPTX from './RollUpOverviewStatPPTX';


const RollUpOverviewAuxStatsRowPPTX = ({ title, peakBuffer, environmentDataPerDay, showPercentIndexed }) => {

  const rowWidths =
    showPercentIndexed ?
    [2, 5] :
    [6, 6];

  return (
    <div className='analytics__roll-up-overview-row-pptx'>
      <div className='row'>
        <div className={`col-md-${rowWidths[0]}`}>
          <h4 className='analytics__roll-up-overview-row-pptx__title'>
            {title}
          </h4>
        </div>
        <div className={`col-md-${rowWidths[1]}`}>
          <div className='analytics__roll-up-overview-row-pptx__stats'>
            <div className='row'>
              <div className='col-md-6'>
                <RollUpOverviewStatPPTX
                  label='Buffer for Peaks'
                  value={`${(peakBuffer * 100).toFixed(0)}%`}
                  boldValue
                />
              </div>
              <div className='col-md-6'>
                <RollUpOverviewStatPPTX
                  label='Recommended Data Per Day'
                  value={`${environmentDataPerDay.toFixed(1)} GB/day`}
                  boldValue
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

RollUpOverviewAuxStatsRowPPTX.propTypes = {
  title: PropTypes.string.isRequired,
  peakBuffer: PropTypes.number.isRequired,
  environmentDataPerDay: PropTypes.number.isRequired,
  showPercentIndexed: PropTypes.bool.isRequired
};

export default RollUpOverviewAuxStatsRowPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/RollUpOverviewAuxStatsRowPPTX.js